import React, { useEffect, useState } from 'react'

import { Flex, Input } from '@chakra-ui/react'

const SimpleTextFilter = ({ value, setValue, direction = 'column' }) => {
  const [filterText, setFilterText] = useState('')

  useEffect(() => {
    if (!value || typeof value !== 'string') {
      setFilterText('')
      return
    }

    setFilterText(value)
  }, [value])

  //Translated

  const handleFilterTextChange = (e) => {
    const newFilterText = e.target.value
    setFilterText(newFilterText)
  }

  const handleOnBlur = () => {
    setValue(filterText)
  }

  return (
    <Flex direction={direction} gap="2" w="100%">
      <Input
        type="text"
        placeholder="Filter by"
        onChange={handleFilterTextChange}
        onBlur={handleOnBlur}
        value={filterText}
        disabled={false}
      />
    </Flex>
  )
}

export default SimpleTextFilter
